(function () {
    'use strict';

    angular.module('swif.openbase')
    .config(route)
    .factory('swifOpenbaseEquipmentService', swifOpenbaseEquipmentService)
    .controller('EquipmentsController', EquipmentsController)
    .controller('OpenbaseEquipmentController', OpenbaseEquipmentController)
    .directive('panelEquipment', panelEquipment)
    .directive('thumbnailEquipment', thumbnailEquipment);

    function route($routeProvider) {
        $routeProvider.when('/configuration/equipments/table_view', {
            templateUrl: 'partials/openbase/equipments_table_view.html',
            controller: 'EquipmentsController',
            reloadOnSearch: false,
            resolve: {
                data: ['swifOpenbaseEquipmentService', function (service) {
                    return service.resolveData();
                }]
            }
        });
    }

    /**
        * @ngdoc service
        * @name swif.openbase.swifOpenbaseEquipmentService
        * @requires swif.framework.swifFrameworkService
    **/
    function swifOpenbaseEquipmentService(swif, swifOpenbaseCustomFieldsService, gettextCatalog) {
        'ngInject';
        var service = {};
        service.resolveData = function (options) {
            //add leaflet
            if (!options) {
                options = {resources: ['leaflet']};
            } else if (options && !options.resources) {
                options.resources = ['leaflet'];
            } else if (options && options.resources) {
                options.resources.push('leaflet');
            }
            return swif.route.check(options).then(function () {
                var data = {};
                return service.createCollection().then(function (collection) {
                    data.equipments = collection;
                    return data;
                });
            });
        };
        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate('equipments', 'equipment', filter, {location: true})
            .then(function (collection) {
                return collection;
            });
        };
        service.getCollection = function () {
            return swif.collections.getCollection('equipments');
        };
        service.callback = function (error, data) {
            var collection = service.getCollection();
            if (collection) {
                collection.defaultActionCallback(error, data);
            }
            service.workflowCallback(error, data);
        };

        service.workflowCallback = function(error, data) {
            if (error) {
                return;
            }
            var callback, model, action, interventionPreValidate;
            var prepareModel = function (data) {
                return {
                    name: swif.i18n.getString('Replace') + ' ' + data.model.name,
                    // site1: data.model.site_id,
                    equipment_id: [data.model.id, data.model.complete_name || data.model.name]
                };
            };
            callback = function (error, data) {
                swif.collections.defaultCallbackMessage(error, data);
            };
            interventionPreValidate = function(data) {
                var validated = swif.collections.preValidate(data);
                if (data.model.create_task) {
                    var inter = data.model;
                    // After being copied, we delete 'task' which is used in form only
                    var ctask = angular.copy(inter.task);
                    delete inter.task;
                    // From 'ctask' we get only ids of assigned services
                    return swif.data.sanitizeData('task', ctask).then(function (sdata) {
                        inter.tasks = [[0, 0, sdata]];
                        return true;
                    });
                }
                return validated;
            }
            if (data.action.id === 'add_intervention_request') {
                model = prepareModel(data);
                action = swif.action.getActionById(
                    'intervention_request',
                    'list', 'add'
                );
                if (action) {
                    swif.action.dispatch(
                        'intervention_request', action, model,
                        {callback: callback}
                    );
                }
            } else if (data.action.id === 'add_intervention') {
                model = prepareModel(data);
                action = swif.action.getActionById(
                    'intervention',
                    'list', 'add'
                );
                if (action) {
                    swif.action.dispatch(
                        'intervention', action, model,
                        {
                            callback: callback,
                            preValidate: interventionPreValidate
                        }
                    );
                }
            }
        };

        service._prepareNewQty = function (data) {
            if (data.model.qty_available >= 0) {
                data.model.new_qty = data.model.qty_available;
            }
            return data;
        };

        service.preValidate = function (data) {
            if (data.model.equipment_reference !== undefined && data.model.equipment_reference === 0) {
                delete data.model.equipment_reference;
            }
            if (_.contains(['add', 'edit'], data.action.id)) {
                service._prepareNewQty(data);
            } else if (data.action.id === 'copy') {
                // _inherits field, must not be copied
                delete data.model.product_product_id;
            }
            swifOpenbaseCustomFieldsService.sanitize(data);
            return service.getCollection().preValidate(data);
        };
        service.preModal = function (data) {
            service.getCollection().preModal(data);
            if (data.action.id === 'add') {
                data.model.qty_available = 1;
                data.model.osm_zoom = 16;
                swif.data.callKw('equipment', 'increment_equipment_reference').then(function (res) {
                    if (res.next_equipment_ref && _.isNumber(res.next_equipment_ref)) {
                        data.model.equipment_reference = res.next_equipment_ref;
                    }
                });
            }
            if (data.action.id === 'edit') {
                var params = {fields: []};
                if (swif.module.modules.openresa) {
                    params.fields = _.union(params.fields, [
                        'color',
                        'optional_product_ids',
                        'option_of_product_ids',
                        'resa_service_manager_ids',
                        'resa_user_manager_ids',
                        'internal_booking',
                        'internal_bookable_notice',
                        'external_booking',
                        'external_bookable_notice',
                        'service_bookable_ids',
                        'partner_type_bookable_ids',
                        'block_booking',
                        'qty_available',
                        'elevation',
                        'geo_point'
                    ]);
                }
                if (!_.isEmpty(params.fields)) {
                    swif.data.get('equipment', data.model.id, params)
                    .then(function (model) {
                        swif.data.updateObj(model, data.model);
                    });
                }
            }
            if(data.action.id === 'copy') {
                console.log("data in copy", data);
                swif.data.callKw('equipment', 'increment_equipment_reference').then(function (res) {
                    if (res.next_equipment_ref && _.isNumber(res.next_equipment_ref)) {
                        data.model.equipment_reference = res.next_equipment_ref;
                    }
                })
            }

        };

        service.getStatesConfig = function () {
            return [
                {id: 'new', name: gettextCatalog.getString('New')},
                {id: 'good', name: gettextCatalog.getString('Good')},
                {id: 'fair', name: gettextCatalog.getString('Fair')},
                {id: 'bad', name: gettextCatalog.getString('Bad')},
                {id: 'unsuitable', name: gettextCatalog.getString('Unsuitable')},
                {id: 'dangerous', name: gettextCatalog.getString('Dangerous')},
                {id: false, name: gettextCatalog.getString('Unknown')}
            ];
        };
        return service;
    }


    function EquipmentsController($scope, openbase, data) {
        'ngInject';
        $scope.equipments = data.equipments;
        $scope.callback = openbase.equipment.callback;
        $scope.preValidate = openbase.equipment.preValidate;
        $scope.preModal = openbase.equipment.preModal;
    }

    function OpenbaseEquipmentController($scope, swif, openbase, carto) {
        'ngInject';
        $scope.modules = swif.module.modules;
        $scope.discountResa = swif.settings.app.features.discountResa;
        $scope.filters = {
            supplier: {},
            category: {fields:  ["id", "name", "complete_name", "is_fluid_meter", "is_active"]},
            parent_id: {fields:  ["id", "name", "complete_name", "equipment_reference", "is_active"]}
        };
        if (!$scope.model.custom_fields) {
            $scope.model.custom_fields = [];
        }
        $scope.equipmentReferenceAlreadyExist = false;
        $scope.formatNameChoices = openbase.utils.selectOneFormatNameChoice;

        // #3069 temporary boolean for customFields
        $scope.patrimonyCustomFields = swif.settings.app.features.patrimonyCustomFields;

        swif.data.addFilter($scope.filters.supplier, 'type_id.product_supplier', '=', true);
        $scope.choices = {states: openbase.equipment.getStatesConfig()};
        $scope.STATES = {};
        _.forEach($scope.choices.states, function (item) {
            $scope.STATES[item.id] = item.name;
        });
        if ($scope.model.id) {
            swif.data.addFilter($scope.filters.parent_id, 'id', '!=', $scope.model.id);
        }

        // equipment.state undefined for creation
        if (!$scope.model.state){
            $scope.model.state = [false, $scope.STATES[false]];
        }
        $scope.onCategoryChange = function (category) {
            $scope.fluidsMeterAndModule = $scope.modules.opengst_fluide && category.is_fluid_meter;
            openbase.customfields.getTemplateFromCategory($scope.model);
        };
        $scope.goToFluidsMetersPanel = function () {
            // same action as clicking on "cancel" button of the generic modal
            $scope.$parent.$parent.cancel();
        }

        $scope.$watch('model.state', function (newV) {
            if (_.isString(newV)) {
                $scope.model.state = [newV, $scope.STATES[newV]];
            }
        });

        $scope.$watch('model.life_duration', function (newV) {
            if (newV) {
                if ($scope.model.date_start) {
                    //compute date end;
                    $scope.model.date_end = moment($scope.model.date_start)
                        .add(newV, 'month')
                        .format('YYYY-MM-DD');
                }
            }
        });


        if (!swif.module.modules.opengst_carto) {
            return;
        }
        $scope.showLeaflet = false;
        $scope.onMapInitialized = onMapInitialized;
        if ($scope.model.osm_zoom) {
            $scope.model._osm_zoom = $scope.model.osm_zoom;
        }
        if ($scope.model.osm_type && $scope.model.osm_id) {
            $scope.model._osm_url = `http://www.openstreetmap.org/${$scope.model.osm_type}/${$scope.model.osm_id}`;
        }
        $scope.setGeometryFromOSM = setGeometryFromOSM;
        $scope.fixHiddenLeaflet = function () {
            setTimeout(function () {
                $scope.showLeaflet = true;
                $scope.$apply();
            }, 200);
        };

        $scope.$watch('model.equipment_reference', function(newV, oldV) {
            if (newV !== oldV) {
                var params = {
                    fields: ['id'],
                    domain: [
                        '&',
                        ['equipment_reference', '!=', false],
                        ['equipment_reference', '=', newV]
                    ]
                };

                if ($scope.model._type === 'patrimoine_equipment' && $scope.model.id) {
                    params.domain.push(['id', '!=', $scope.model.id]);
                }

                swif.data.searchRead('equipment', params).then(function(matchedEquipmentCodes) {
                    console.log(matchedEquipmentCodes);
                    if (matchedEquipmentCodes.ids.length > 0) {
                        $scope.equipmentReferenceAlreadyExist = true;
                        $scope.matchedEquipment = matchedEquipmentCodes.ids[0];
                    } else {
                        delete $scope.matchedEquipment;
                        $scope.equipmentReferenceAlreadyExist = false;
                    }

                    $scope.form['model.equipment_reference'].$setValidity(
                        'default',                          // default don't exist: just highlight the field in red without any message
                        matchedEquipmentCodes.ids.length === 0  // if there is no matched site found
                    );
                });
            }
        });

        $scope.$watch('model._osm_zoom', setZoom);
        $scope.$watch('model._osm_url', setOSMTypeAndId);
        function onMapInitialized (map) {
            $scope.map = map;
            if ($scope.model.osm_zoom) {
                map.setZoom($scope.model.osm_zoom);
            }
            createOrUpdateGeojsonLayer();
        }
        function setZoom (zoom) {
            if (zoom === undefined) {
                $scope.model.osm_zoom = false;
            } else {
                $scope.model.osm_zoom = zoom;
                if ($scope.map) {
                    $scope.map.setZoom(zoom);
                }
            }
        }
        function setOSMTypeAndId (url) {
            //'http://www.openstreetmap.org/way/201328809#map=19/47.19211/-1.69555&layers=D'
            if (url) {
                var splited = url.split('/').slice(3,5);
                if (splited.length === 2) {
                    $scope.model.osm_type = splited[0];
                    $scope.model.osm_id = splited[1].split('#')[0];
                }
            } else {
                $scope.model.osm_type = false;
                $scope.model.osm_id = false;
                $scope.model.geometry = false;
            }
        }
        function setGeometryFromOSM () {
            getOSMGeometry(
                $scope.model.osm_type,
                $scope.model.osm_id
            ).then(function (geometry) {
                $scope.model.geometry = JSON.stringify(geometry);
                createOrUpdateGeojsonLayer();
            });
        }
        function getOSMGeometry (type, id) {
            //download data
            var promise;
            if (type === 'node') {
                promise = carto.osmAPI.getNodeFull(id);
            } else if (type === 'way') {
                promise = carto.osmAPI.getWayFull(id);
            } else if (type === 'relation') {
                promise = carto.osmAPI.getRelationFull(id);
            }
            if (promise) {
                return promise.then(function (data) {
                    return carto.osmtogeojson.togeojson(data);
                }, onOSMError);
            } else {
                return $q.when();
            }
        }
        function createOrUpdateGeojsonLayer() {
            if ($scope.geojsonlayer && $scope.map) {
                if ($scope.map.hasLayer($scope.geojsonlayer)) {
                    $scope.map.removeLayer($scope.geojsonlayer);
                }
                delete $scope.geojsonlayer;
            }
            if ($scope.model.geometry && $scope.map) {
                var features = JSON.parse($scope.model.geometry);
                $scope.geojsonlayer = L.geoJson(features).addTo($scope.map);
            }
        }
        function onOSMError(error) {
            $scope.osmError = error;
        }

    }

    function panelEquipment(swif) {
        'ngInject';
        var linked = function(scope) {
            swif.attachment.addAttachments(scope.item);
            scope.modules = swif.module.modules;
        };
        var directive = swif.panel.create_directive('equipment', undefined, linked);
        directive.templateUrl = 'partials/openbase/panel-equipment.html';
        return directive;
    }


     function thumbnailEquipment(swif) {
        'ngInject';
        var ret = swif.panel.create_directive('equipment');
        ret.scope.light = '=?';
        ret.templateUrl = 'partials/openbase/thumbnail-equipment.html';
        return ret;
    }

})();
